export var TYPE_ROLES = {

    REVIEW: 6,

}